import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Card } from './shared/Card';
import { Badge } from './shared/Badge';
import { CheckCircleIcon, ClockIcon, PlayCircleIcon, BookOpenIcon } from 'lucide-react';
export const DailyChallenge: React.FC = () => {
  const [completedChallenges, setCompletedChallenges] = useState<string[]>([]);
  const challenges = [{
    id: 'video',
    type: 'Video',
    title: 'Creative Problem Solving',
    description: 'Watch this short video on how to approach complex problems in the workplace',
    xp: 50,
    time: '2 min',
    icon: <PlayCircleIcon size={20} data-id="element-661" />,
    color: 'purple'
  }, {
    id: 'reflection',
    type: 'Reflection',
    title: 'Your Ideal Work Environment',
    description: 'Take a moment to describe your perfect work setting and what energizes you',
    xp: 30,
    time: '5 min',
    icon: <BookOpenIcon size={20} data-id="element-662" />,
    color: 'blue'
  }, {
    id: 'action',
    type: 'Action',
    title: 'Industry Research',
    description: 'Research one company in your target industry and note what interests you about them',
    xp: 70,
    time: '10 min',
    icon: <ClockIcon size={20} data-id="element-663" />,
    color: 'green'
  }];
  const completeChallenge = (id: string) => {
    if (!completedChallenges.includes(id)) {
      setCompletedChallenges([...completedChallenges, id]);
    }
  };
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 0.5
  }} data-id="element-664">
      <div className="mb-6" data-id="element-665">
        <div className="flex justify-between items-center mb-2" data-id="element-666">
          <h1 className="text-2xl font-bold text-white" data-id="element-667">
            Daily Career Challenge
          </h1>
          <span className="text-[#B8C0E0]" data-id="element-668">
            {completedChallenges.length}/{challenges.length} Completed
          </span>
        </div>
        <p className="text-[#B8C0E0]" data-id="element-669">
          Complete daily challenges to earn XP and career insights
        </p>
      </div>
      <div className="space-y-6" data-id="element-670">
        {challenges.map(challenge => {
        const isCompleted = completedChallenges.includes(challenge.id);
        return <motion.div key={challenge.id} initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3
        }} data-id="element-671">
              <Card className={isCompleted ? 'border-[#19D3DA]' : ''} data-id="element-672">
                <div className="flex items-start" data-id="element-673">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center mr-4 ${challenge.color === 'purple' ? 'bg-[#7D56F4]/20 text-[#7D56F4]' : challenge.color === 'blue' ? 'bg-[#19D3DA]/20 text-[#19D3DA]' : 'bg-[#4CAF50]/20 text-[#4CAF50]'}`} data-id="element-674">
                    {challenge.icon}
                  </div>
                  <div className="flex-1" data-id="element-675">
                    <div className="flex justify-between items-start" data-id="element-676">
                      <div data-id="element-677">
                        <Badge color={challenge.color as any} data-id="element-678">
                          {challenge.type}
                        </Badge>
                        <h3 className="font-medium mt-2" data-id="element-679">{challenge.title}</h3>
                      </div>
                      <span className="text-[#FFD700] font-bold" data-id="element-680">
                        +{challenge.xp} XP
                      </span>
                    </div>
                    <p className="text-sm text-[#B8C0E0] my-2" data-id="element-681">
                      {challenge.description}
                    </p>
                    <div className="flex justify-between items-center mt-4" data-id="element-682">
                      <div className="flex items-center text-sm text-[#B8C0E0]" data-id="element-683">
                        <ClockIcon size={14} className="mr-1" data-id="element-684" />
                        {challenge.time}
                      </div>
                      <button onClick={() => completeChallenge(challenge.id)} className={`py-2 px-4 rounded-full text-sm font-medium flex items-center ${isCompleted ? 'bg-[#19D3DA]/20 text-[#19D3DA]' : 'bg-gradient-to-r from-[#7D56F4] to-[#19D3DA] text-white'}`} data-id="element-685">
                        {isCompleted ? <>
                            <CheckCircleIcon size={16} className="mr-1" data-id="element-686" />
                            Completed
                          </> : 'Start Challenge'}
                      </button>
                    </div>
                  </div>
                </div>
              </Card>
            </motion.div>;
      })}
      </div>
      {completedChallenges.length === challenges.length && <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} className="mt-8 bg-gradient-to-r from-[#7D56F4]/20 to-[#19D3DA]/20 rounded-lg p-4 text-center" data-id="element-687">
          <div className="text-2xl mb-2" data-id="element-688">🎉</div>
          <h3 className="text-lg font-medium mb-1" data-id="element-689">
            All Challenges Completed!
          </h3>
          <p className="text-sm text-[#B8C0E0]" data-id="element-690">
            Come back tomorrow for new challenges
          </p>
        </motion.div>}
    </motion.div>;
};